import { toast } from "react-toastify";

import {
  API_advance_onboarding_step,
  API_run_onboarding_automation,
} from "../../../constants";
import { postRightworkAPI } from "../requests/utilities/requests";
import { setOnboardingIntent } from "./onboardingNavigation";
import { isSampleLocation } from "./onboardingFeatureDraft";

export function onboardingCompanyStoreId(companyId, stores = []) {
  const companyStores = stores.filter(store => String(store.company) === String(companyId) && store.onboarding_status !== "inactive");
  return (companyStores.find(store => !isSampleLocation(store) || store.pos_provider ||
    (store.pos_details_json && Object.keys(store.pos_details_json).length > 0)) || companyStores[0])?.id;
}

export async function handleOnboardingAction(action, options = {}) {
  if (!action) {
    return;
  }

  const {
    companyId,
    companyStoreId,
    setCurrentTab,
    refreshSummary,
    setRequestedSection,
    openModal,
    homeStore,
    changeHomeStore,
  } = options;

  if (action.externalUrl) {
    const baseUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    const targetUrl = action.externalUrl.startsWith("http")
      ? action.externalUrl
      : `${baseUrl}${action.externalUrl}`;

    if (action.openInNewTab) {
      window.open(targetUrl, "_blank", "noopener,noreferrer");
      return;
    }

    window.location.assign(targetUrl);
    return;
  }

  if (action.automation) {
    toast.loading("Starting automation...", { autoClose: false });
    try {
      await postRightworkAPI(API_run_onboarding_automation, {
        company_id: companyId,
        store_id: action.store_id,
        automation: action.automation,
      });
      toast.dismiss();
      toast.success("Automation started.", { autoClose: 3000 });
      await refreshSummary?.();
    } catch (error) {
      toast.dismiss();
      toast.error(
        error?.response?.data?.system?.message || "Unable to start automation.",
        { autoClose: 3000 }
      );
    }
    return;
  }

  if (action.modal && openModal) {
    openModal(action.modal, action.modalProps);
    return;
  }

  if (action.modal && setCurrentTab) {
    setCurrentTab("onboardingCenter");
    setOnboardingIntent({ ...action, tab: "onboardingCenter" });
    return;
  }

  if (action.taskKey) {
    try {
      await postRightworkAPI(API_advance_onboarding_step, {
        company_id: companyId,
        store_id: action.store_id,
        task_key: action.taskKey,
        action: action.action || "complete",
      });
      await refreshSummary?.();
      if (action.action === "pos_sales" && action.tab && setCurrentTab) {
        if (companyStoreId && changeHomeStore && Number(companyStoreId) !== Number(homeStore)) {
          await changeHomeStore(companyStoreId);
        }
        setCurrentTab(action.tab);
        setOnboardingIntent({ ...action, company_id: companyId });
      }
      return true;
    } catch (error) {
      toast.error(
        error?.response?.data?.system?.message || "Unable to update onboarding step.",
        { autoClose: 3000 }
      );
      return false;
    }
  }

  if (action.section && setRequestedSection) {
    setRequestedSection(action.section);
  }

  if (action.tab && setCurrentTab) {
    const targetStore = action.store_id || companyStoreId;
    if (
      targetStore &&
      changeHomeStore &&
      Number(targetStore) !== Number(homeStore)
    ) {
      await changeHomeStore(targetStore);
    }
    // Select the parent first: mounted Settings pages consume the intent
    // synchronously, and a later parent navigation would overwrite the subtab.
    setCurrentTab(action.tab);
    // Pass the selected store to the editor explicitly: the home-store props
    // can still reference the sample location when navigation is consumed.
    setOnboardingIntent(targetStore ? { ...action, store_id: targetStore } : action);
  }
}
